import { Component, ViewChild, ElementRef } from "@angular/core";
import { NavController, PopoverController } from "ionic-angular";

import { HelperServiceProvider } from "./../../common/services/helper.service";
import { APIServiceProvider } from "./../../common/services/api.service";

declare var google;

@Component({
  selector: "page-map",
  templateUrl: "map.html"
})
export class MapPage {
  constructor(
    public nav: NavController,
    public helperService: HelperServiceProvider,
    public apiService: APIServiceProvider,
    public popoverCtrl: PopoverController
  ) {}

  all_address: any = [];

  @ViewChild("map")
  mapElement: ElementRef;
  map: any;
  geocoder: any = new google.maps.Geocoder();

  //create empty LatLngBounds object
  bounds: any = new google.maps.LatLngBounds();
  infowindow: any = new google.maps.InfoWindow();

  public postParams: any = {
    order_status: 3,
    dispatched_to: localStorage.getItem("user-id"),
    received_order: 0
  };

  ionViewDidLoad() {
    this.initMap();
    this.getOrdersDispatched();
  }

  initMap() {
    let latLng = new google.maps.LatLng(22.7196, 75.8577);

    let mapOptions = {
      center: latLng,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
  }

  addMarker(geometry) {
    this.addMarker(geometry);

    let marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: geometry
    });

    let content = "<h4>Information!</h4>";

    this.addInfoWindow(marker, content);
  }

  addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content
    });

    google.maps.event.addListener(marker, "click", () => {
      infoWindow.open(this.map, marker);
    });
  }

  codeAddress(i, address, content) {
    let self = this;

    this.geocoder.geocode({ address: address }, function(results, status) {
      if (status === "OK") {
        let geometry = results[0].geometry.location;

        self.map.setCenter(geometry);
        var marker = new google.maps.Marker({
          map: self.map,
          animation: google.maps.Animation.DROP,
          position: geometry
        });

        google.maps.event.addListener(
          marker,
          "click",
          (function(marker, i) {
            return function() {
              self.infowindow.setContent(content);
              self.infowindow.open(self.map, marker);
            };
          })(marker, i)
        );

        var loc = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng()
        );
        self.bounds.extend(loc);
      } else {
        alert("Geocode was not successful for the following reason: " + status);
      }
    });
  }

  getOrdersDispatched() {
    this.apiService.post("orders/all", this.postParams).subscribe(data => {
      var results = data["data"]["data"];

      if (results.length !== 0) {
        for (var i = 0; i < results.length; i++) {
          var address_comp = results[i].customer_data;
          var address = "";

          if (address_comp["address"]) {
            address += address_comp["address"]["village"] + ", ";
            address += address_comp["address"]["tehsil"] + ", ";
            address += address_comp["address"]["district"] + ", ";
            address += address_comp["address"]["state"] + ", India, ";

            this.all_address.push({ data: address_comp, address: address });

            var content =
              "<strong>Dispatched</strong><br>" +
              address_comp.first_name +
              " " +
              address_comp.first_name +
              ", " +
              address_comp.mobile_no +
              "<br>" +
              address;

            this.codeAddress(i, address, content);
          }
        }

        this.getOrdersReceived();
      }
    });
  }

  getOrdersReceived() {
    this.apiService
      .post("orders/all", {
        order_status: 5,
        dispatched_to: localStorage.getItem("user-id"),
        received_order: 1
      })
      .subscribe(data => {
        var results = data["data"]["data"];

        if (results.length !== 0) {
          for (var i = 0; i < results.length; i++) {
            var address_comp = results[i].customer_data;
            var address = "";

            address += address_comp["village"] + ", ";
            address += address_comp["tehsil"] + ", ";
            address += address_comp["district"] + ", ";
            address += address_comp["state"] + ", India, ";

            this.all_address.push({ data: address_comp, address: address });

            var content =
              "<strong>Received</strong><br>" +
              address_comp.first_name +
              " " +
              address_comp.first_name +
              ", " +
              address_comp.mobile_no +
              "<br>" +
              address;

            this.codeAddress(i, address, content);
          }

          this.map.fitBounds(this.bounds);
          this.map.panToBounds(this.bounds);
          this.map.setZoom(5);
        }
      });
  }
}

//



// WEBPACK FOOTER //
// ./src/pages/map/map.ts